import React from 'react';

function CloseFairness({ handleClose }) {
  return (
    <div className='close-btn' onClick={handleClose}>
      <span className='icon-close' />
    </div>
  );
}
export default CloseFairness;
